<app-modal-dialog title="Send Invitation To Partner" (dismiss)="cancel()">

    <main>
        @if(hasEditMailTemplatePermission()) {
          <p>An Email will be send to the partner specified email address, using the <b>standard mail template</b></p>
          <br>
          <p>You might want to <a href="#" (click)="goToMailTemplate($event)">preview or customize the template</a>, before sending your invitation</p>
        }
        @else {
          <p>An Email will be send to the partner specified email address, using the <b>standard mail template</b></p>
          <br>
          <p>You might want to preview or customize the template, before sending your invitation</p>
        
        }
    </main>
   
    <footer>
      <div class="button-container">
        <app-button primary width="100%" (buttonClick)="send()">Send Invitation</app-button>
        <app-button secondary width="100%" (buttonClick)="cancel()">Cancel</app-button>
      </div>
    </footer>
  
</app-modal-dialog>
   